<template>
  <v-card>
    <v-toolbar color="primary mb-2" dark dense>
      <v-toolbar-title short>
        Query Preview
        <span class="text-caption">(Showing first {{ showingResultsCount }} records)</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- NOTE hiding this for now - need to improve user permissions accessibility -->
      <v-btn
        small
        dark
        @click="toggleShowSql"
      >{{ showHideSqlText }}</v-btn>

      <v-chip class="ma-2" color="teal" label text-color="white">
        <v-icon left>mdi-database-export</v-icon>
        Total Records ({{ totalCount }})
      </v-chip>

      <v-chip class="ma-2" color="teal" label text-color="white">
        <v-icon left>mdi-email</v-icon>{{ emailCount }} ({{ emailPct }}%)
      </v-chip>

      <v-chip class="ma-2" color="teal" label text-color="white">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon left>mdi-home-group</v-icon>{{ addressCount }} ({{ addressPct }}%)
          </template>
          <span>Have an address</span>
        </v-tooltip>
      </v-chip>

      <v-btn icon>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" @click="sendCloseEvent">mdi-close</v-icon>
          </template>
          <span>Close</span>
        </v-tooltip>
      </v-btn>
    </v-toolbar>
    <v-container> <!-- previews page overflow on campaign migration -->
      <v-responsive>
        <v-data-table
          v-if="!showSql"
          :headers="tableHeaders"
          :items="tableData"
          item-key="one_off_id()"
          dense
          class="elevation-1"
          :loading="showLoading"
          loading-text="Loading... Please wait"
        ></v-data-table>
      </v-responsive>
      <v-textarea
        v-if="showSql"
        v-model="tableSql"
        full-width
        readonly
        auto-grow
      ></v-textarea>
    </v-container>
  </v-card>
</template>

<script>

const { v4: uuid } = require('uuid')

export default {
  name: 'query-preview-table',
  props: {
    tableData: {
      type: Array,
      required: true
    },
    tableColumns: {
      type: Array,
      required: true
    },
    tableCounts: {
      type: Object,
      required: true
    },
    tableSql: {
      type: String,
      required: false
    },
    showLoading: {
      type: Boolean,
      required: true
    }
  },

  data: function () {
    return {
      totalCount: 0,
      emailCount: 0,
      addressCount: 0,
      emailPct: 0,
      addressPct: 0,
      showSql: false
    }
  },
  watch: {
    tableCounts: function (newCounts, oldCounts) {
      if (Object.keys(newCounts).length > 0) {
        this.totalCount = newCounts.total
        this.emailCount = newCounts.email
        this.addressCount = newCounts.address
        this.emailPct = this.calcPercentage(this.emailCount, this.totalCount)
        this.addressPct = this.calcPercentage(this.addressCount, this.totalCount)
      } else {
        this.resetCounts()
      }
    }
  },
  methods: {
    calcPercentage: function (sliceCount, totalCount) {
      try {
        const pct = ((sliceCount / totalCount) * 100).toFixed(2)
        if (isNaN(pct)) {
          return 0
        } else {
          return pct
        }
      } catch (error) {
        return 0
      }
    },
    resetCounts: function () {
      this.totalCount = 0
      this.emailCount = 0
      this.addressCount = 0
      this.emailPct = 0
      this.addressPct = 0
    },
    one_off_id: function () {
      return uuid()
    },
    sendCloseEvent: function () {
      this.$emit('close-query-preview')
    },
    toggleShowSql: function () {
      this.showSql = !this.showSql
    }
  },
  computed: {
    tableHeaders () {
      return this.tableColumns.map(col => {
        return { text: col, value: col }
      })
    },
    showingResultsCount () {
      return this.tableData.length
    },
    showHideSqlText () {
      if (this.showSql) {
        return 'Hide SQL'
      } else {
        return 'Show SQL'
      }
    }
  }
}
</script>

<style>
</style>
